import React from 'react';

const EvidenceServicesSection = () => {
  return null;
};

export default EvidenceServicesSection;